import React from 'react'
import { Checkbox } from 'antd'
import { BulkUpdateTableCellActionsWrapper } from './BulkUpdateTableCellActionsWrapper'

interface BulkUpdateTableCheckboxCellRendererProps {
  value: boolean
  isLastColumn: boolean
  totalRows: number
  rowIndex: number
  onDeleteRow: (index: number) => void
  onChange: (checked: boolean) => void
}

export const BulkUpdateTableCheckboxCellRenderer: React.FC<
  BulkUpdateTableCheckboxCellRendererProps
> = ({ value, isLastColumn, totalRows, rowIndex, onDeleteRow, onChange }) => {
  const handleChange = (e: { target: { checked: boolean } }) => {
    onChange(e.target.checked)
  }

  return (
    <BulkUpdateTableCellActionsWrapper
      isLastColumn={isLastColumn}
      totalRows={totalRows}
      onDeleteRow={onDeleteRow}
      rowIndex={rowIndex}
    >
      <Checkbox checked={value} onChange={handleChange} />
    </BulkUpdateTableCellActionsWrapper>
  )
}
